var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPremiumSelfcareSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4269 4.18666L15.856 13.1867C15.5494 14.26 14.5684 15 13.4522 15H3.97695C2.31606 15 1.11691 13.4103 1.5731 11.8133L4.14397 2.81334C4.45057 1.74001 5.43157 1 6.54782 1H16.023C17.6839 1 18.8831 2.58966 18.4269 4.18666Z",
    fill: "white",
    stroke: "#5096E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.01629 10.9615C6.94819 11.314 7.09413 11.5 7.44439 11.5H8.07682C8.42709 11.5 8.65087 11.314 8.71897 10.9615L9.03032 9.33636H10.3341C10.7038 9.33636 11.0735 9.25804 11.4043 9.1014C12.3384 8.66084 13 7.66224 13 6.48741C13 5.67483 12.64 5.02867 11.9881 4.71538C11.6768 4.56853 11.307 4.5 10.8789 4.5H8.79681C8.44654 4.5 8.22276 4.68601 8.15466 5.03846L7.01629 10.9615ZM9.32221 7.86783L9.69193 5.96853H10.5481C11.0152 5.96853 11.2487 6.23287 11.2487 6.64406C11.2487 7.1042 11.0443 7.50559 10.7233 7.72098C10.5676 7.82867 10.3633 7.86783 10.1492 7.86783H9.32221Z",
    fill: "#5096E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremiumSelfcareSmall);
export default __webpack_public_path__ + "static/media/premium-selfcare-small.10b9f1f9ae17e7f1427cd3a688fbb6a8.svg";
export { ForwardRef as ReactComponent };